import { render, staticRenderFns } from "./InformacionPago.vue?vue&type=template&id=4e1d7cf8&scoped=true"
import script from "./InformacionPago.vue?vue&type=script&lang=ts"
export * from "./InformacionPago.vue?vue&type=script&lang=ts"
import style0 from "./InformacionPago.vue?vue&type=style&index=0&id=4e1d7cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d7cf8",
  null
  
)

export default component.exports